import React from 'react';
import './Toolbar.scss';
import EventIcon from '../../Varios/EventIcons';
import { useIconColors } from 'Context/IconColorContext';

// Toolbar for calendar
const iconStyle = { width: '2.2em', height: '2.2em', display: 'block' };

const Toolbar = () => {
    const iconColors = useIconColors();
    return (
        <div className="toolbarCalendar">
            {iconColors && iconColors.map(iconInfo => (
                <div className="icon-container" key={iconInfo.id} title={iconInfo.descripcion}>
                    <EventIcon tipo={iconInfo.id} style={iconStyle}/>
                    <span className="d-none d-md-inline">{iconInfo.descripcion}</span>
                </div>
            ))}
        </div>
    );
};

export default Toolbar;
